'use strict';

const errorSvg = require('../images/error.svg');
const clearSvg = require('../images/clear.svg');

angular.module('docketbook').
  controller('scopeNavController', function (addressBookService, userService, uuid, $scope, $state, $window, $location, $stateParams, accessControl, $rootScope, jobService, orderService) {
    $scope.listView = $state.current.data ? $state.current.data.listView : '';

    $scope.myDocketbook = false;
    $scope.errorSvgImagePath = errorSvg;
    $scope.clearSvgImagePath = clearSvg;
    if ($stateParams.myDocketbook == true) {
      $scope.myDocketbook = true;
    }

    $scope.currentState = $state.current;
    $scope.currentOrg = accessControl.currentOrg();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentUser = accessControl.currentUser();
    $scope.organisations = accessControl.allowedOrganisations();
    $scope.orgUnitSelected = [];
    $scope.userCanDoAction = userService.userCanDoAction;
    $scope.hasJobs = true
    $scope.hasOrders = true
    $scope.connections = [];

    $scope.newLook = function() {
      mixpanel.track('Go To React');
      // Save new look preference to local storage
      localStorage.setItem(`react-view`, true)
      window.location.href = window.location.href.replace('?applicationId=io.docketbook.webui&authType=session', '').replace('/#/', '/app/')
    }

    function updateConnectionCount() {
      $scope.connections = []

      userService.getUserConnections(connections => {
        $scope.connections = $scope.connections.concat(connections)
      })

      if ($scope.currentOrg != null) {
        addressBookService.getFilteredConnections({ statuses: 'requested' }, connections => {
          $scope.connections = $scope.connections.concat(connections.filter(connection => connection.status == 'requested' && connection.sourceId != $scope.currentOrg.id))
        })
      }
    }

    updateConnectionCount()

    $rootScope.updateScopeNavConnections = function () {
      updateConnectionCount()
    }


    jobService.getJobs({ limit: 1, offset: 0 }, function (returnData) {
      $scope.hasJobs = returnData.length > 0
    })

    orderService.getOrders({ limit: 1, offset: 0 }, function (returnData) {
      $scope.hasOrders = returnData.length > 0
    })



    var getChildren = group => {
      var children = $scope.currentOrg.groups.filter(g => g.parent == group.id && g.active)
      return _.flatten([group, ...children.map(g => getChildren(g))])
    }

    var rootGroup = $scope.currentOrg ? $scope.currentOrg.groups.filter(x => x.parent == null)[0] : null
    $scope.sortedGroups = rootGroup ? getChildren(rootGroup) : []

    $rootScope.$on('OrganisationsListRefreshed', function () {
      $scope.organisations = accessControl.allowedOrganisations();
    });

    $scope.openMenu = function ($mdOpenMenu, ev) {
      $mdOpenMenu(ev);
    };

    $scope.mobileNav = false;

    $scope.myCompaniesClick = function () {
      localStorage.removeItem(`orgGroup-${$scope.currentUser.id}`)
    }

    $scope.logout = function () {
      accessControl.logout($scope.urlVersion, '');
    }

    $scope.goToDockets = function () {
      $state.go('main.groupDockets', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }

    $scope.goToContacts = function () {
      $state.go('main.groupContacts', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
    }

    $scope.goToInvoices = function (subRoute) {
      window.location.href = `/app/org/${$scope.currentOrg.id}/group/${$scope.currentOrgGroup.id}/invoices/list/${subRoute}`
    }

    $scope.openOrgUnits = function (orgId) {
      if ($("#org" + orgId + " ul.inner").css('display') == 'none') {
        $("#org" + orgId + " ul.inner").slideDown();
        $("#org" + orgId + " .openIcon .downIcon").hide();
        $("#org" + orgId + " .openIcon .upIcon").show();
      } else {
        $("#org" + orgId + " ul.inner").slideUp();
        $("#org" + orgId + " .openIcon .downIcon").show();
        $("#org" + orgId + " .openIcon .upIcon").hide();
      }
    }

    $scope.openScopeDropdown = function () {
      if ($("#orgListDropdown").css('display') == 'none') {
        $("#orgListDropdown").slideDown(function () {
          if ($scope.currentOrg != null) {
            $("#org" + $scope.currentOrg.id + " ul.inner").slideDown();
          }
        });
        $(".orgScopeIcon").addClass('open');
      } else {
        $("#orgListDropdown").slideUp();
        $(".orgScopeIcon").removeClass('open');
      }
    }

    $scope.closeScopeDropdown = function () {
      $("#orgListDropdown").slideUp();
      $(".orgScopeIcon").removeClass('open');
    }

    $scope.openUserDropdown = function () {
      if ($("#userDropdown").css('display') == 'none') {
        $("#userDropdown").slideDown();
        $("#userDropdownSelector .downIcon").hide();
        $("#userDropdownSelector .upIcon").show();
      } else {
        $("#userDropdown").slideUp();
        $("#userDropdownSelector .downIcon").show();
        $("#userDropdownSelector .upIcon").hide();
      }
    }

    $scope.changeOrganisation = function (org) {
      if (org != null) {
        $state.go('main.groupDashboard', { orgId: org.id, groupId: 'home' });
      } else {
        $state.go('main.dashboard');
      }
    }

    $scope.changeOrganisationGroup = function (org, orgGroup) {
      $state.go('main.groupDashboard', { orgId: org.id, groupId: orgGroup.id });
    }

    $scope.toggleMobileNav = function () {
      $scope.mobileNav = !$scope.mobileNav;
    }

    $scope.goTo = function (view) {
      var currentPath = $location.path();
      if (currentPath == "/" + view) {
        $scope.mobileNav = false;
      }
      $location.path(view);
    }

    $scope.goToDirect = function (href) {
      $window.location.href = href;
    }

    $scope.openHelp = function () {
      $window.open('https://help.docketbook.com.au/hc/en-us/signin?return_to=https%3A%2F%2Fhelp.docketbook.com.au%2Fhc%2Fen-us&locale=en-us', '_blank');
    }

    $scope.openAdminDropdown = function () {
      if ($(".adminDropdown").css('display') == 'none') {
        $(".adminDropdown").slideDown();
      } else {
        $(".adminDropdown").slideUp();
      }
    }

    var addGroupBreadcrumb = function (breadcrumbs, successCb) {
      if ($scope.currentOrg.groups.length === 0) {
        return successCb(breadcrumbs);
      }
      if ((breadcrumbs[breadcrumbs.length - 1].parent !== null) && (breadcrumbs[breadcrumbs.length - 1].parent !== undefined)) {
        // get full parent group
        const priorLength = breadcrumbs.length;
        for (var i = 0; i < $scope.currentOrg.groups.length; i++) {
          if ($scope.currentOrg.groups[i].id == breadcrumbs[breadcrumbs.length - 1].parent) {
            breadcrumbs.push($scope.currentOrg.groups[i]);
            break;
          }
        }
        if (breadcrumbs.length === priorLength) {
          //we haven't added anything to the breadcrumb trail - we can't go any higher
          //in the chain - bail out.
          return successCb(breadcrumbs);
        }
        addGroupBreadcrumb(breadcrumbs, successCb);
      } else {
        successCb(breadcrumbs);
      }
    }

    $scope.generateGroupsBreadcrumb = function () {
      var breadcrumbGroups = [];
      if ($scope.currentOrgGroup) {
        breadcrumbGroups.push($scope.currentOrgGroup);
        addGroupBreadcrumb(breadcrumbGroups, function (completeList) {
          completeList.reverse();
          $scope.groupBreadcrumbs = completeList;
        });
      } else {
        $scope.groupBreadcrumbs = [];
      }
    }

    $scope.generateGroupsBreadcrumb();

    $scope.openNotificationsSlider = function () {
      $(".notificationsSlideOuterContainer").css({ 'display': 'block' });
      $(".notificationsSlideUnderlay").fadeIn(200);
      $(".notificationsSlideOuterContainer").animate({
        'right': '0px'
      }, 200);
    }

    $scope.closeNotificationsSlider = function () {
      $(".notificationsSlideUnderlay").fadeOut(200);
      $(".notificationsSlideOuterContainer").animate({
        'right': '-300px'
      }, 200, function () {
        $(".notificationsSlideOuterContainer").css({ 'display': 'none' });
      });
    }

    /* Notifications Summary Controls */

    $scope.resetNotificationsSummary = function () {
      $scope.notificationsSummary = {};
      $scope.notificationsSummary.loading = true;
      $scope.notificationsSummary.notifications = [];
    }

    $scope.resetNotificationsSummary();

    $scope.getUserNotifications = function () {
      var notifications = [];

      /**** Contact Share Messages ****/
      addressBookService.getUserContactShares(null, function (contactSharesList) {
        $scope.injectContactShareNotifications(contactSharesList, notifications, function () {
          $scope.notificationsSummary.loading = false;
          $scope.notificationsSummary.notifications = notifications;
        });
      });
    }

    $scope.getUserNotifications();

    $scope.injectContactShareNotifications = function (contactSharesList, notificationsList, cb) {
      for (var i = 0; i < contactSharesList.length; i++) {
        var contactShare = contactSharesList[i];
        var newNotification = { type: 'contactShare' };
        newNotification.title = contactShare.senderName + ' sent you the contact information for ' + contactShare.displayName;
        newNotification.dateTime = "";
        newNotification.contactShare = contactShare;
        newNotification.id = uuid.v4();
        notificationsList.push(newNotification);
      }

      cb();
    }

    $scope.viewNotificationMessage = function (notification) {
      $scope.message = {};
      $scope.message.title = notification.title;
      $scope.message.dateTime = notification.dateTime;
      $scope.message.type = notification.type;

      if (notification.type == 'contactShare') {
        var initials = "";
        if (notification.contactShare.displayName) {
          var split = notification.contactShare.displayName.split(' ');
          if (split.length == 1) {
            initials = split[0].charAt(0).toUpperCase();
          } else if (split.length > 1) {
            initials = split[0].charAt(0).toUpperCase();
            initials += split[1].charAt(0).toUpperCase();
          }
        }
        if (notification.contactShare.comment) {
          $scope.message.body = notification.contactShare.comment.replace(/\n/g, '<br/>');
        }
        $scope.message.contactShare = notification.contactShare;
        $scope.message.contactShare.initials = initials;
      }

      $("#viewMessageModal").fadeIn(100);
      $("#viewMessageModal .modalContainer").draggable();
    }

    $scope.closeViewMessageModal = function () {
      $("#viewMessageModal").fadeOut(100);
    }

    $scope.closeNotification = function (notification) {
      $("#" + notification.id).fadeOut(200, function () {
        if (notification.type == 'contactShare') {
          addressBookService.deleteContactShare(notification.contactShare.id, function (success) {
            for (var i = 0; i < $scope.notificationsSummary.notifications.length; i++) {
              if ($scope.notificationsSummary.notifications[i].id == notification.id) {
                $scope.notificationsSummary.notifications.splice(i, 1);
                break;
              }
            }
          });
        }
      });
    }

    $scope.addContactShareToExisting = function (contactShare) {
      $("#viewMessageModal").fadeOut(100);
      if ($scope.currentOrg != null) {
        $scope.updateContactFromParent(null, null, contactShare, function (contactSelected) {
        });
      } else {
        $scope.selectOrganisationUnit(function (orgUnit) {
          $scope.updateContactFromParent(orgUnit.organisation, orgUnit.id, contactShare, function (contactSelected) {
          });
        });
      }
    }

    $scope.newContactFromShare = function (contactShare) {
      $("#viewMessageModal").fadeOut(100);
      if ($scope.currentOrg != null) {
        $scope.createContactFromParent(null, null, contactShare, function (contactSelected) {
        });
      } else {
        $scope.selectOrganisationUnit(function (orgUnit) {
          if (orgUnit != null) {
            $scope.createContactFromParent(orgUnit.organisation, orgUnit.id, contactShare, function (contactSelected) {
            });
          }
        });
      }
    }

    $scope.selectOrganisationUnit = function (cb) {
      $("#selectOrgUnitModal").fadeIn(100);
      $scope.orgUnitList = [];
      $scope.orgUnitSelected = [];
      var organisations = accessControl.allowedOrganisations();
      for (var i = 0; i < organisations.length; i++) {
        for (var j = 0; j < organisations[i].groups.length; j++) {
          $scope.orgUnitList.push(organisations[i].groups[j]);
        }
      }
      $scope.selectOrgUnitCallback = cb;
    }

    $scope.closeOrgUnitSelectList = function () {
      $("#selectOrgUnitModal").fadeOut(100);
      $scope.selectOrgUnitCallback(null);
    }

    $scope.orgUnitSelectContinue = function () {
      $("#selectOrgUnitModal").fadeOut(100);
      $scope.selectOrgUnitCallback($scope.orgUnitSelected[0]);
    }

    /***** New Group Modal ******/
    $scope.newOrgGroup = function () {
      /*mixpanel.track("Clicked Create New Org Group");

      if ($scope.currentOrg.groups.length >= $scope.currentOrg.planFeatures.includedOrganisationGroups) {

        return;
      }
      $("#newGroupModal").fadeIn(100);
      $scope.newGroup = {};
      $scope.newGroup.timezone = $scope.currentOrgGroup.timezone;
      $scope.createNewGroupFromParent($scope.currentOrgGroup, function(newGroupCreated) {
        if ( newGroupCreated != null ) {
          mixpanel.track("Created New Org Group");
          accessControl.refreshAndGetAllowedOrganisations(function(orgsList) {
            $scope.allOrganisations = orgsList;
            $state.go('main.groupDashboard', {orgId: $scope.currentOrg.id, groupId: newGroupCreated.id});
          });
        } else {
          mixpanel.track("Abandoned New Org Group");
        }
      });*/

      $state.go('companySettings.groups', { orgId: $scope.currentOrg.id })
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/scopeNav.js